import React from "react"
import {
   Alert,
   Button,
   Col,
   Container,
   Form,
   FormControl,
   InputGroup,
   OverlayTrigger,
   Row,
   Tooltip,
   CloseButton
} from "react-bootstrap"
import { useParams, useNavigate } from "react-router-dom"
import { isLoggedIn } from "../../api/AuthService"

import { UpdateTrainingStatus } from "../../api/AuthService"
import { SearchOptionValues, IS_USER_TRAINED } from "../../constant/Constants"

import Logo from "../../resource/img/logo.png"
import RYE from "./RYE.svg"
import Logout from "../login/Logout"
import "../main.css"
import SearchResultDisp from "./SearchResultDisp"
import VendorPreference from "./VendorPreference"

// HOC to provide router props to class component
function withRouter(Component) {
   function ComponentWithRouterProp(props) {
      let params = useParams()
      let navigate = useNavigate()

      return (
         <Component
            {...props}
            params={params}
            navigate={navigate}
         />
      )
   }

   return ComponentWithRouterProp
}

class SearchComponent extends React.Component {
   constructor(props) {
      super(props)
      this.videoUrl = `${process.env.REACT_APP_TRAINING_URL}`
      this.state = {
         loading: false,
         topMargin: {},
         message: "",
         searchValue: "",
         optionValue: this.props.params && this.props.params.searchType
            ? this.props.params.searchType
            : "gcas",
         visible: sessionStorage.getItem("freshLogin") ? true : false,
         show: true,
         vendorModal: false,
         showVideoOverlay: false,
         videoError: false,
         videoFinished: false,
         confirmationChecked: false,
         submittingConfirmation: false,
      }

      this.searchText = React.createRef()
      this.videoRef = React.createRef()
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleRadioChange = this.handleRadioChange.bind(this)
      this.handleOnFocus = this.handleOnFocus.bind(this)
      this.handleBannerClose = this.handleBannerClose.bind(this)
      this.expiryDate = localStorage.getItem("expirationDate")
      this.userRole = localStorage.getItem("role")
   }

   handleVendorModal = () => {
      this.setState({
         vendorModal: !this.state.vendorModal
      })
   }

   handleBannerClose() {
      this.setState({
         show: false,
      })
      localStorage.removeItem("expirationDate");
   }

   closeDisclaimer() {
      sessionStorage.removeItem("freshLogin")
      this.setState({
         visible: false,
      })
   }

   handleSubmit(e) {
      if (!isLoggedIn()) {
         this.props.navigate("/")
      }
      e.preventDefault()
      if (this.validateForm()) {
         this.setPropsValue()
         this.setSessionValuesForSearchOptions(this.state.optionValue)
      }

      this.closeDisclaimer()
   }

   validateForm() {
      let formIsValid = true
      if (this.searchText.current.value === "") {
         formIsValid = false
         this.setState({
            message: "* Please enter some value above.",
            loading: false,
         })
      }
      return formIsValid
   }

   handleChange = (e) => {
      this.setState({
         message: "",
      })
   }

   handleOnFocus = (e) => {
      this.closeDisclaimer()
   }

   handleVideoOverlay = () => {
      this.setState({ showVideoOverlay: true })
   }

   handleVideoEnd = () => {
      this.setState({ videoFinished: true })
   }

   handleVideoError = () => {
      this.setState({ videoError: true })
   }

   handleConfirmationChange = (e) => {
      this.setState({ confirmationChecked: e.target.checked })
   }

   submitVideoConfirmation = async () => {
      if (!this.state.confirmationChecked) {
         alert("Please confirm that you have watched the video.")
         return
      }

      this.setState({ submittingConfirmation: true })

      try {
         // Send confirmation to backend - isUserTrained value based on checkbox
         const isUserTrained = this.state.confirmationChecked
         // const response = await Api.post(`/search-api/update/video-training-confirmation/${isUserTrained}`)

         const response = await UpdateTrainingStatus(IS_USER_TRAINED, isUserTrained)

         if (response.status === 200) {
            localStorage.setItem("isUserTrained", isUserTrained.toString())
            this.setState({
               showVideoOverlay: false,
               videoFinished: false,
               confirmationChecked: false,
               submittingConfirmation: false
            })
         } else {
            alert('Failed to submit confirmation , Please try again.')
            localStorage.setItem("isUserTrained", isUserTrained.toString())
            this.setState({
               showVideoOverlay: false,
               videoFinished: false,
               confirmationChecked: false,
               submittingConfirmation: false
            })
         }
      } catch (error) {
         console.error('Error submitting video confirmation:', error)
         alert('Failed to submit confirmation. Please try again.')
         localStorage.setItem("isUserTrained", "true")

         // Close modal
         this.setState({
            showVideoOverlay: false,
            videoFinished: false,
            confirmationChecked: false,
            submittingConfirmation: false
         })
      }
   }

   setPropsValue = () => {
      this.setState({
         loading: true,
         topMargin: { marginTop: "3%" },
         searchValue: btoa(encodeURIComponent(this.searchText.current.value)),
      })
   }

   componentDidMount() {
      sessionStorage.removeItem("breadCrumb")

      if (!isLoggedIn()) {
         this.props.navigate("/")
      }

      const unreleasedPartName = localStorage.getItem("unreleasedPartName")
      if (unreleasedPartName && unreleasedPartName !== "") {
         localStorage.removeItem("unreleasedPartName")
         localStorage.removeItem("calledFrom")
         this.props.navigate(`/unreleasedData/${unreleasedPartName}`)
         return
      }
      const isUserTrained = localStorage.getItem("isUserTrained")
      const userType = localStorage.getItem("userType")
      const showVideo = process.env.REACT_APP_SHOW_VIDEO === "true"
      if (isUserTrained === "false" && userType === "SBM" && showVideo) {
         this.handleVideoOverlay()
      }
      if (this.props.params.searchText != null) {
         this.searchText.current.value = decodeURIComponent(atob(this.props.params.searchText))
         if (this.props.params.searchType) {
            this.setState({
               optionValue: this.props.params.searchType,
            })
         }

         this.setPropsValue()
      } else if (
         sessionStorage["lastSearchWithOption"] &&
         sessionStorage["lastSearchWithOption"] !== ""
      ) {
         var searchAndType = sessionStorage["lastSearchWithOption"]
         searchAndType = decodeURIComponent(atob(searchAndType))
         var arry = searchAndType.split("_")

         this.searchText.current.value = arry[0] ? arry[0] : ""

         if (arry[1]) {
            this.setState({
               optionValue: arry[1],
            })
         }
         this.setPropsValue()
      }
   }

   setSessionValuesForSearchOptions = (optionVal) => {
      sessionStorage["lastSearchWithOption"] = ""
      var searchCacheKey = `${this.searchText.current.value}_${optionVal}`
      sessionStorage.setItem("lastSearchWithOption", btoa(encodeURIComponent(searchCacheKey)))
   }

   handleRadioChange(event) {
      var selectedOption = ""

      this.closeDisclaimer()

      if (event.target.childNodes[0]) {
         selectedOption = event.target.childNodes[0].value
      } else {
         selectedOption = event.target.value
      }

      this.setState({
         optionValue: selectedOption,
      })

      if (this.validateForm()) {
         this.setPropsValue()
         this.setSessionValuesForSearchOptions(selectedOption)
      }
   }

   render() {
      return (
         <React.Fragment>
            <Container fluid className="contentBackground sticky-top shadow" style={{ marginLeft: "0px" }}>
               <Row>
                  <Col md="12" style={{ paddingLeft: "3px" }}>
                     <img src={Logo} alt="logo" />
                     <Logout handleVendorModal={this.handleVendorModal} />
                  </Col>
               </Row>
            </Container>
            <Container fluid>
               {this.expiryDate && this.state.show && (
                  <Row>
                     <Col md="12" className="notice">
                        {this.userRole !== "" ? (
                           <p style={{ display: "inline-block" }}>
                              Your access will expire on {this.expiryDate}. Please contact your Sponsor for renewal. If the renewal request has been submitted, please ignore this message.
                              <CloseButton style={{ marginLeft: "30px" }} onClick={this.handleBannerClose} />
                           </p>

                        ) : (

                           <p style={{ display: "inline-block" }}>
                              Your access will expire on {this.expiryDate}. Click
                              <a href={process.env.REACT_APP_RENEWAL_LINK} target="_blank" rel="noopener noreferrer"> here
                              </a> to renew now. If renewal request has been submitted, please ignore this message.
                              <CloseButton style={{ marginLeft: "30px" }} onClick={this.handleBannerClose} />
                           </p>
                        )}
                     </Col>
                  </Row>
               )}
               <Row>
                  <Col>
                     <div className="searchContent" style={this.state.topMargin}>
                        <Form onSubmit={this.handleSubmit} className="loginForm">
                           <Form.Group
                              controlId="searchBox"
                              style={{ marginBottom: "0rem" }}
                           >
                              <InputGroup>
                                 <FormControl
                                    className={`placeHolderText searchBox ${this.state.blinkUser}`}
                                    ref={this.searchText}
                                    placeholder="&#61442; What are you Looking For?"
                                    type="text"
                                    onChange={this.handleChange}
                                    onFocus={this.handleOnFocus}
                                 />
                                 <Button bsPrefix="searchBtnText" type="submit">
                                    Search
                                 </Button>
                              </InputGroup>
                              <InputGroup>
                                 {SearchOptionValues && (
                                    <div className="radbtnClass">
                                       {SearchOptionValues.map((item, index) => (
                                          <OverlayTrigger
                                             key={index}
                                             delay={{ show: 300, hide: 300 }}
                                             overlay={
                                                <Tooltip id={item.value}>
                                                   {item.toolTip}
                                                </Tooltip>
                                             }
                                             placement="bottom"
                                          >
                                             <span
                                                key={index}
                                                onClick={this.handleRadioChange.bind(
                                                   this
                                                )}
                                                style={{ cursor: "pointer" }}
                                             >
                                                <input
                                                   id={item.value}
                                                   value={item.value}
                                                   checked={
                                                      this.state.optionValue ===
                                                      item.value
                                                   }
                                                   type="radio"
                                                   readOnly
                                                />{" "}
                                                {item.display} &nbsp;
                                             </span>
                                          </OverlayTrigger>
                                       ))}
                                    </div>
                                 )}
                              </InputGroup>
                           </Form.Group>
                        </Form>
                        <Row>
                           <Col>
                              <p style={{ marginLeft: "1.1rem" }} className="labels">
                                 {this.state.message}
                              </p>
                           </Col>
                        </Row>
                     </div>
                  </Col>
               </Row>
               {this.state.visible && (
                  <Col md="12" className="mb-5">
                     <Alert variant="primary">
                        <Alert.Heading style={{ color: "red", textAlign: "justify" }}>
                           Please ensure you are logged in using Chrome.{process.env.REACT_APP_ENVIORMENT}
                        </Alert.Heading>
                        <hr />
                        <p style={{ textAlign: "justify" }}>
                           This system is the property of this Corporation/organization,
                           and is intended for the use of authorized users only. All
                           activities of individuals using this computing system with or
                           without authority, or in excess of their authority, may be
                           monitored and recorded by system personnel. If any such
                           monitoring reveals evidence of criminal activity or is in
                           violation of foreign or U.S. state or federal law, such
                           evidence may be provided to law enforcement officials and/or
                           used for further legal action by this Corporation and/or the
                           organization's Information Protection group. Unauthorized use
                           of this system is prohibited and may result in revocation of
                           access, disciplinary action and/or legal action. The company
                           reserves the right to monitor and review user activity, files
                           and electronic messages.
                        </p>
                        <p>
                           <b>Reminder:</b> Information transmitted to a foreign person on
                           this network may be subject to applicable Export Control laws.
                           Contact your Export Coordinator for assistance.
                        </p>
                        <p>
                           This is a private computer/communications facility. Access to
                           it for any reason must be specifically authorized.System
                           personnel will/may monitor for unauthorized activity. Anyone
                           using this system expressly consents to such monitoring. Your
                           continued access, if unauthorized, may result in criminal
                           and/or civil proceedings.
                        </p>
                        <p>
                           Activity in P&G's Spec Reader is automatically recorded and may
                           be used to produce aggregated reporting / statistical analysis.
                           By using the Spec Reader System, you accept automatic recording
                           of your activities.
                        </p>
                        <hr />
                        <p className="mb-0">
                           <h4>
                              Please accept sole responsibility for your password and
                              access. It is not to be shared with anyone.
                           </h4>
                        </p>
                     </Alert>
                  </Col>
               )}
               {this.state.loading && this.state.searchValue && this.state.searchValue.trim() && SearchResultDisp && (
                  <Row>
                     <Col md="12" className="mb-5">
                        <SearchResultDisp
                           history={this.props.navigate}
                           searchType={this.state.optionValue}
                           searchData={this.state.searchValue.trim()}
                        />
                     </Col>
                  </Row>
               )}
               <VendorPreference show={this.state.vendorModal} handleVendorModal={this.handleVendorModal} />
               {this.state.showVideoOverlay && (
                  <div className="video-overlay" style={{
                     position: 'fixed',
                     top: 0,
                     left: 0,
                     width: '100%',
                     height: '100%',
                     backgroundColor: 'rgba(0, 0, 0, 0.9)',
                     zIndex: 9999,
                     display: 'flex',
                     alignItems: 'flex-start',
                     justifyContent: 'center',
                     overflowY: 'auto',
                     padding: '20px 0'
                  }}>
                     <div style={{
                        width: '90%',
                        maxWidth: '700px',
                        position: 'relative',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        padding: '20px',
                        margin: 'auto',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                     }}>

                        {!this.state.videoError ? (
                           <>
                              <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
                                 Welcome to Spec Reader. Please watch the training video below and click the checkbox to confirm you have completed the video
                              </h3>
                              <video
                                 controls
                                 crossOrigin="anonymous"
                                 ref={this.videoRef}
                                 src={this.videoUrl}
                                 width="100%"
                                 onEnded={this.handleVideoEnd}
                                 onError={this.handleVideoError}
                                 style={{ borderRadius: '4px' }}
                              >
                                 Your browser does not support the video tag.
                              </video>
                           </>
                        ) : (
                           <Alert variant="danger" style={{ marginTop: '20px', textAlign: 'center' }}>
                              <Alert.Heading>Video Loading Error</Alert.Heading>
                              <p>
                                 Issue streaming the training video due to connectivity issues,
                                 Please contact SpecReaderExt.im@pg.com for help.
                              </p>
                              <hr />
                              <div style={{ marginTop: '15px' }}>
                                 <Button
                                    variant="primary"
                                    onClick={() => this.setState({
                                       showVideoOverlay: false,
                                       videoError: false
                                    })}
                                 >
                                    Skip video
                                 </Button>
                              </div>
                           </Alert>
                        )}

                        {!this.state.videoError && (
                           <div style={{ marginTop: '20px', textAlign: 'center' }}>
                              {!this.state.videoFinished && (
                                 <div>
                                    <Button
                                       variant="success"
                                       onClick={this.handleVideoEnd}
                                    >
                                       I have finished watching the video
                                    </Button>
                                 </div>
                              )}

                              {this.state.videoFinished && (
                                 <>
                                    <div style={{ marginBottom: '15px' }}>
                                       <input
                                          type="checkbox"
                                          id="videoConfirmation"
                                          checked={this.state.confirmationChecked}
                                          onChange={this.handleConfirmationChange}
                                          style={{ marginRight: '8px' }}
                                       />
                                       <label htmlFor="videoConfirmation">
                                          I confirm that I have watched the video
                                       </label>
                                    </div>
                                    <Button
                                       variant="primary"
                                       onClick={this.submitVideoConfirmation}
                                       disabled={!this.state.confirmationChecked || this.state.submittingConfirmation}
                                    >
                                       {this.state.submittingConfirmation ? 'Submitting...' : 'Continue'}
                                    </Button>
                                 </>
                              )}
                           </div>
                        )}
                     </div>
                  </div>
               )}
            </Container>
            {this.state.visible && (
               <footer style={{ textAlign: "center", padding: "16px 24px 10px", marginTop: "auto" }}>
                  <a
                     href="https://rateexperience.pg.com/ratings?id=32665"
                     target="_blank"
                     rel="noopener noreferrer"
                     style={{ textDecoration: "none", color: "inherit", display: "inline-block", width: "min-content" }}
                  >
                     <img src={RYE} alt="Rate Your Experience" style={{ display: "block", width: "80%", height: "auto", margin: "0 auto" }} />
                     <div style={{ fontSize: "13px", marginTop: "4px", color: "#ffffff", whiteSpace: "nowrap" }}>Rate Your Experience</div>
                  </a>
               </footer>
            )}
         </React.Fragment>
      )
   }
}

export default withRouter(SearchComponent)